import { useCallback } from 'react';
import { CustomButton } from '../../../../../components/CustomButton';
import RModal from '../../../../../components/Rsuite/Modal';
import api from '../../../../../services/api';
import { toastSuccess } from "../../../../../toasts";

const DeletarRegrasPromo = ({ open, handleClose, rule, setRule, setRules }) => {
  const handleDelete = useCallback(async () => {
    await api.delete(`promocao-regra/${rule.Id}`)
    .then(() => {
        setRules((prev) => prev.filter((rl) => rl.Id !== rule.Id));
        toastSuccess('Regra removida com sucesso.');
        setRule(null);
        handleClose();
    })
    .catch(error => console.log('Erro ao remover regra ' + error));
  },[handleClose, rule?.Id, setRule, setRules]);

  return(
    <RModal
      open={open}
      onClose={handleClose}
      title={"Remover regra"}
      footer={
        <>
          <CustomButton appearance="default" onClick={handleClose}>
            Cancelar
          </CustomButton>
          <CustomButton color="red" onClick={handleDelete}>Deletar</CustomButton>
        </>
      }
    >
      Tem certeza que deseja remover regra ?
    </RModal>
  )
}

export default DeletarRegrasPromo;
